import { type Ref } from 'vue'

const queue = new Set<Ref<boolean>>()
let running = false

export function useRenderQueue() {
  function processQueue() {
    const maxTimePerFrame = 4
    let batchSize = 2
    let count = 0
    const startTime = performance.now()

    for (const item of queue) {
      item.value = true
      queue.delete(item)
      count++

      if (count > batchSize || performance.now() - startTime > maxTimePerFrame) {
        break
      }
    }

    if (count === batchSize && performance.now() - startTime < maxTimePerFrame / 2) {
      batchSize = Math.min(10, batchSize * 2)
    } else if (count < batchSize) {
      batchSize = Math.max(1, Math.floor(batchSize / 2))
    }

    if (queue.size) {
      requestAnimationFrame(processQueue)
    } else {
      running = false
    }
  }

  function push(value: Ref<boolean>) {
    queue.add(value)
    if (!running) {
      running = true
      requestAnimationFrame(processQueue)
    }
  }

  return {
    push,
    delete: queue.delete.bind(queue),
  }
}
